// import components
import { styled, Box } from '@mui/material';

export const StyledBottomHeaderBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.background.paper,
  borderBottom: `1px solid ${theme.palette.divider}`,
  justifyContent: 'space-between'
}));
